export const appFiles = "FAa";
export default {appFiles};